import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';
import Typography from '../components/Typography';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(9),
    marginBottom: theme.spacing(9),
  },
  button: {
    border: '4px solid currentColor',
    borderRadius: 0,
    height: 'auto',
    padding: theme.spacing(2, 5),
  },
  link: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buoy: {
    width: 60,
  },
});

function ProductSmokingHero(props) {
  const { classes, language } = props;

  return (
    <Container className={classes.root} component="section">
      <Button className={classes.button}>
        <a style={{textDecoration:"none"}} href={"mailto:febri_widhawanto@ymail.com?subject=Online%20Asset%20Manager%20Help&body=%0A%0A%0AYour Question Here..%0A%0A%0A"}>
        <Typography variant="h4" component="span">
        {language==="en-US"?"Got any questions? Need help?":"Konsultasi dulu?"}
        </Typography>
        </a>
      </Button>
      <Typography variant="subtitle1" className={classes.link}>
        {language==="en-US"?"We are here to help. Get in touch!":"Kami ada di sini untuk membantumu!"}
      </Typography>
      <img src="/static/producBuoy.svg" className={classes.buoy} alt="buoy" />
    </Container>
  );
}

ProductSmokingHero.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductSmokingHero);